import { useEffect, useState } from "react";

export default function Admin() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/admin/assemblee", {
      credentials: "include", // pour Basic Auth Apache
    })
      .then(res => {
        if (!res.ok) throw new Error("Unauthorized");
        return res.json();
      })
      .then(data => {
        setRecords(data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  const remove = async (id) => {
    if (!window.confirm("Supprimer cette entrée ?")) return;

    await fetch(`/api/admin/assemblee/${id}`, {
      method: "DELETE",
      credentials: "include",
    });

    setRecords(records.filter(r => r.id !== id));
  };

  if (loading) return <div className="p-6">Chargement…</div>;

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">Administration</h1>

      <table className="w-full border border-gray-200">
        <thead>
          <tr className="bg-gray-100 text-left">
            <th className="p-3">ID</th>
            <th className="p-3">Date</th>
            <th className="p-3">Crawled</th>
            <th className="p-3">Titre</th>
            <th className="p-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          {records.map(r => (
            <tr key={r.id} className="border-t">
              <td className="p-3">{r.id}</td>
              <td className="p-3">{r.date}</td>
              <td className="p-3" style={{ fontSize: "0.7em" }}>{r.timestamp_crawled}</td>
              <td className="p-3">{r.titre}</td>
              <td className="p-3">
                <button
                  onClick={() => remove(r.id)}
                  className="text-red-600 hover:underline"
                >
                  Supprimer
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

